import './base-styles/Shell.css';
import './base-styles/index.css';
// import './base-styles/ShipmentConfirmationStyle.css';
import { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import {
  LoadingScreen,
  Landing,
  Login,
  AgentAuthEmployeeNumber,
  AgentAuthYellowPassword,
  AgentProcessSelection,
  ClientRetrievalScanAWB,
  ClientRetrievalVerificationCode,
  ClientRetrievalName,
  ClientRetrievalSignature,
  ClientRetrievalPiece,
  ClientRetrievalIssues,
  InsertIssues,
  InsertPiece,
  InsertProcessSelection,
  InsertScanPID,
  ThankYou,
  RemoveIssues,
  RemovePiece,
  RemoveProcessSelection,
  RemoveValidateAWB,
  AgentLockerFix,
} from './pages';
import { navigationPages } from '../models/types';
import { useActions, useTypedSelector } from '../hooks';
import { indexedDBInstance } from '../indexedDB/indexedDBInstance';
import { EarlyExitModal, UserInactivityModal } from './common';
import { AuthenticatorHelper, ScannerHelper, LockerHelper, DebugPanel } from './helpers';

const Shell: React.FC = () => {
  const { sessionReset, updateUserInactivitySeconds } = useActions();
  const authenticating = useTypedSelector(({ session }) => {
    return session.authenticating;
  });
  const needsLogin = useTypedSelector(({ session }) => {
    return session.needsLogin;
  });
  const token = useTypedSelector((state) => {
    return state.session.dhlApiToken;
  });
  const settingUpScanners = useTypedSelector(({ devices }) => {
    return devices.settingUpScanners;
  });
  const settingUpLocker = useTypedSelector(({ devices }) => {
    return devices.settingUpLocker;
  });
  //Catching submit events
  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
      }
      if (event.code === 'KeyY' && event.ctrlKey && event.shiftKey) {
        if (token) {
          indexedDBInstance.clear();
          sessionReset();
        }
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [token, sessionReset]);

  const renderContent = () => {
    if (authenticating || settingUpScanners || settingUpLocker) {
      if (needsLogin) {
        return <Login />;
      }
      return <LoadingScreen />;
    }
    return (
      <Switch>
        <Route exact path="/">
          <Landing />
        </Route>
        <Route path={`/${navigationPages.LANDING}`}>
          <Landing />
        </Route>
        <Route path={`/${navigationPages.AGENT_AUTH_EMPLOYEE_NUMBER}`}>
          <AgentAuthEmployeeNumber />
        </Route>
        <Route path={`/${navigationPages.AGENT_AUTH_YELLOW_PASSWORD}`}>
          <AgentAuthYellowPassword />
        </Route>
        <Route path={`/${navigationPages.AGENT_PROCESS_SELECTION}`}>
          <AgentProcessSelection />
        </Route>
        <Route path={`/${navigationPages.AGENT_LOCKER_FIX}`}>
          <AgentLockerFix />
        </Route>
        <Route path={`/${navigationPages.CLIENT_RETRIEVAL_SCAN_AWB}`}>
          <ClientRetrievalScanAWB />
        </Route>
        <Route path={`/${navigationPages.CLIENT_RETRIEVAL_VERIFICATION_CODE}`}>
          <ClientRetrievalVerificationCode />
        </Route>
        <Route path={`/${navigationPages.CLIENT_RETRIEVAL_NAME}`}>
          <ClientRetrievalName />
        </Route>
        <Route path={`/${navigationPages.CLIENT_RETRIEVAL_SIGNATURE}`}>
          <ClientRetrievalSignature />
        </Route>
        <Route path={`/${navigationPages.CLIENT_RETRIEVAL_PIECE}`}>
          <ClientRetrievalPiece />
        </Route>
        <Route path={`/${navigationPages.CLIENT_RETRIEVAL_ISSUES}`}>
          <ClientRetrievalIssues />
        </Route>
        <Route path={`/${navigationPages.INSERT_ISSUES}`}>
          <InsertIssues />
        </Route>
        <Route path={`/${navigationPages.INSERT_PIECE}`}>
          <InsertPiece />
        </Route>
        <Route path={`/${navigationPages.INSERT_PROCESS_SELECTION}`}>
          <InsertProcessSelection />
        </Route>
        <Route path={`/${navigationPages.INSERT_SCAN_PID}`}>
          <InsertScanPID />
        </Route>
        <Route path={`/${navigationPages.REMOVE_ISSUES}`}>
          <RemoveIssues />
        </Route>
        <Route path={`/${navigationPages.REMOVE_PIECE}`}>
          <RemovePiece />
        </Route>
        <Route path={`/${navigationPages.REMOVE_PROCESS_SELECTION}`}>
          <RemoveProcessSelection />
        </Route>
        <Route path={`/${navigationPages.REMOVE_VALIDATE_AWB}`}>
          <RemoveValidateAWB />
        </Route>
        <Route path={`/${navigationPages.THANK_YOU}`}>
          <ThankYou />
        </Route>
      </Switch>
    );
  };

  const getDeviceHelpers = () => {
    const bypass = process.env.REACT_APP_BYPASS_MODE === 'true' ?? false;
    if (bypass) {
      return null;
    }
    return (
      <>
        <ScannerHelper />
        <LockerHelper />
      </>
    );
  };
  return (
    <div id="main" onClick={() => updateUserInactivitySeconds(0)}>
      <EarlyExitModal />
      <UserInactivityModal />
      <AuthenticatorHelper />
      {getDeviceHelpers()}
      <DebugPanel />
      <div id="shell" className="main-container">
        {renderContent()}
      </div>
    </div>
  );
};
export default Shell;
